import type { ReactNode } from 'react';

export const symbol_flashlight_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M784-109 630-263v123q0 24.75-17.62 42.37Q594.75-80 570-80H390q-24.75 0-42.37-17.63Q330-115.25 330-140v-423L77-816q-9-9-9-21t9-21q9-9 21.5-9t21.5 9l707 707q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9Zm-394-31h180v-183L390-503v363Zm330-680v146q0 9.27-2.31 17.77T710-640l-88 128q-8 12-19.27 13-11.28 1-20.73-5-4.4-3-7.7-7.5T570-521q-1-5 .13-11 1.12-6 4.87-12l85-125v-35H372q-13.08 0-21.54-8.68-8.46-8.67-8.46-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h288v-56H300q-13.08 0-21.54-8.68-8.46-8.67-8.46-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h360q24.75 0 42.38 17.62Q720-844.75 720-820ZM480-413ZM372-704Z"
		/>
	</svg>
);
